import React, { useEffect } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import { useBanner } from '@xingternal/banner';

import { RootState } from '@/ducks';
import { hideNotification } from '@/ducks/notification';

// This component is only needed to display LO Search Alerts errors
export const ErrorStatusBanner: React.VFC = () => {
  const { showBanner, hideBanner } = useBanner();
  const dispatch = useDispatch();
  const notificationType = useSelector(({ search }: RootState) => search.notification.type);
  const showNotification = useSelector(({ search }: RootState) => search.notification.show);
  const errorMessage = useSelector(({ search }: RootState) => search.notification.message);

  const showError = showNotification && notificationType === 'error';

  useEffect(() => {
    const handleOnBannerClose = (): void => {
      dispatch(hideNotification());
    };

    const bannerConfig = {
      children: <FormattedMessage id={errorMessage} />,
      handleOnClose: handleOnBannerClose,
    };

    showError ? showBanner(bannerConfig) : hideBanner();
  }, [dispatch, errorMessage, hideBanner, showBanner, showError]);

  return null;
};
